// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner-content b[data-v-51b50f40],.banner-content strong[data-v-51b50f40]{font-size:13.5px}.banner-content p[data-v-51b50f40]{margin:0}.fade-enter-active[data-v-51b50f40],.fade-leave-active[data-v-51b50f40]{transition:opacity .5s ease-in-out}.fade-enter-from[data-v-51b50f40],.fade-leave-to[data-v-51b50f40]{opacity:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
